module.exports = __webpack_public_path__ + "static/img/poliklinika_bagatin.ab74440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/poliklinika_bagatin.png
// module id = e/yC
// module chunks = 0